module.exports = __webpack_public_path__ + "img/2.630c05d9.jpg";